import React from 'react';
import { CodeBlock } from 'react-code-block';
import { useCopyToClipboard } from 'react-use';
import '@fortawesome/fontawesome-svg-core/styles.css';
import YouTube from "react-youtube";

function LegoL85Component({ code, language }) {
    code = `{/* L85 Color Bar Top Content Block */}
                                            <div className="lego l085">
                                                <div className="headerColorBar">
                                                    <h3>Vaccinations and your Steroid Injection</h3>
                                                </div>
                                                <div className="contentContainer">
                                                    <p>To ensure effectiveness of your COVID-19 vaccine, COVID-19
                                                        booster, Flu
                                                        vaccine, and any other vaccine and to improve your ability to
                                                        monitor
                                                        potential side effects, <span className="boldItalic">you should speak with your provider if:</span>
                                                    </p>
                                                    <ul>
                                                        <li>You had the vaccine in the last 2 weeks.</li>
                                                        <li>You plan to have the vaccine.</li>
                                                        <li>You are immunocompromised.</li>
                                                        <li>If you have any questions regarding your procedure, contact
                                                            your
                                                            ordering provider’s office.
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            {/* End L85 Color Bar Top Content Block */}`;
    language = 'jsx';
    const [state, copyToClipboard] = useCopyToClipboard();

    const copyCode = () => {
        // Logic to copy `code`
        copyToClipboard(code);
    };

    return (
        <CodeBlock code={code} language={language}>
            <div className="relative">
                <CodeBlock.Code className="bg-black">
                    <div className="table-row">
                        <CodeBlock.LineNumber className="table-cell pr-4 text-sm text-gray-500 text-right select-none" />
                        <CodeBlock.LineContent className="table-cell">
                            <CodeBlock.Token />
                        </CodeBlock.LineContent>
                    </div>
                </CodeBlock.Code>
                <div className="buttonContainer">
                    <button className="btn btn-primary ml-auto" onClick={copyCode}>
                        <i className="fa-solid fa-copy"></i> {state.value ? 'Copied!' :  'Copy code'}
                    </button>
                </div>
            </div>
        </CodeBlock>
    );
}

export default LegoL85Component;